import { sharedSchema } from "@shared-database/pgSchema";
import { leoID, timestampColumns } from "@shared-database/utils";
import { sql, type SQL } from "drizzle-orm";
import { boolean, index, text, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import type { z } from "zod";

/**
 * USER MODEL with Next-Auth
 */
export const User = sharedSchema.table(
  "User",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    id: leoID("id"),
    name: text("name"),
    email: text("email").notNull(),
    isAdmin: boolean("isAdmin").default(false).notNull(),
    image: text("image"),
    updatedAt: timestamp("updatedAt", { mode: "date" }).defaultNow().notNull(),
    leoId: text("leoId").generatedAlwaysAs(
      (): SQL => sql`
        CASE
            WHEN "Shared"."User"."email" LIKE '%@leo-pharma.com' THEN LOWER(split_part(${User.email}, '@', 1))
            ELSE NULL
        END`,
    ),
  },
  (table) => [index("User_emailIdx").on(table.email)],
);
export const insertUserSchema = createInsertSchema(User);
export type InsertUserType = z.infer<typeof insertUserSchema>;
export type UpdateUserType = Pick<
  z.infer<typeof insertUserSchema>,
  "name" | "email" | "image" | "id" | "updatedAt"
>;
export type SelectUserType = typeof User.$inferSelect;
